const NETWORK = 'networks';

export const CATEGORY_ACTOR = {
	MISC: 'misc',
};

export const CATEGORY_ANIM = {
	MISC: 'misc',
	MODIFIER: 'modifiers',
	NETWORK,
	PROP: 'prop',
	SUBNET: 'subnet',
	TIMING: 'timing',
};
export const CATEGORY_AUDIO = {
	ANALYSER: 'analyser',
	EFFECTS: 'effects',
	INPUTS: 'inputs',
	INSTRUMENTS: 'instruments',
	MISC: 'misc',
	NETWORK,
};

export const CATEGORY_COP = {
	ADVANCED: 'advanced',
	FILTER: 'filters',
	INPUT: 'inputs',
	MISC: 'misc',
	NETWORK,
};
export const CATEGORY_EVENT = {
	CAMERA: 'cameras',
	INPUT: 'inputs',
	MISC: 'misc',
	SCENE: 'scene',
	NETWORK,
};
export const CATEGORY_GL = {
	ADVANCED: 'advanced',
	COLOR: 'color',
	CONVERSION: 'conversion',
	DYNAMICS: 'dynamics',
	GEOMETRY: 'geometry',
	GLOBALS: 'globals',
	LIGHTING: 'lighting',
	LOGIC: 'logic',
	MATH: 'math',
	PHYSICS: 'physics',
	QUAT: 'quat',
	SDF: 'sdf',
	TRIGO: 'trigo',
	UTIL: 'util',
	INSTANCE: 'instance',
};
export const CATEGORY_JS = {
	COLOR: 'color',
	CONVERSION: 'conversion',
	DYNAMICS: 'dynamics',
	GEOMETRY: 'geometry',
	GLOBALS: 'globals',
	LOGIC: 'logic',
	MATH: 'math',
	QUAT: 'quat',
	TRIGO: 'trigo',
	UTIL: 'util',
	INSTANCE: 'instance',
};
export const CATEGORY_MAT = {
	ADVANCED: 'advanced',
	INSTANCE: 'instances',
	LINE: 'lines',
	MESH: 'meshes',
	NETWORK,
	POINTS: 'points',
	VOLUME: 'volumes',
};
export const CATEGORY_OBJ = {
	ADVANCED: 'advanced',
	AUDIO: 'audio',
	CAMERA: 'cameras',
	GEOMETRY: 'geometries',
	LIGHT: 'lights',
	NETWORK,
	TRANSFORM: 'transform',
};
export const CATEGORY_ROP = {
	CSS: 'css',
	NETWORK,
	WEBGL: 'webgl',
};

export const CATEGORY_SOP = {
	ADVANCED: 'advanced',
	ANIMATION: 'animation',
	ATTRIBUTE: 'attributes',
	AUDIO: 'audio',
	DYNAMICS: 'dynamics',
	HELPERS: 'helpers',
	INPUT: 'inputs',
	LIGHTS: 'lights',
	MAP: 'maps',
	MISC: 'misc',
	MODIFIER: 'modifiers',
	NETWORK,
	PHYSICS: 'physics',
	PRIMITIVES: 'primitives',
	RENDER: 'render',
	SUBNET: 'subnet',
};
export const CATEGORY_POST = {
	ADVANCED: 'advanced',
	BLUR: 'blur',
	COLOR: 'color',
	EFFECT: 'effect',
	MISC: 'misc',
	NETWORK,
};
